import Card from "components/card";
import React from "react";
import { columns } from "../columns";
import { useEffect, useState } from "react";
import { getAllStatus, updateStatus } from "../functions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Typography, Box, Tooltip } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PedidosDrawer from "./PedidosDrawer";
import DeletePedido from "./DeletePedido";
import OrderSummaryModalPDF from "./OrderSummary/OrderSummaryModal";
import { showMessage } from "store/modules/Message";
import EventSummary from "./EventSummary/EventSummary";
import OrderCutMainModal from "./OrderCut/OrderCutMainModal";
import StampingOrderMainModal from "./StampingOrder/StampingOrderMainModal";
import OrderBordadoMain from "./OrderBordado/OrderBordadoMain";
import DataGridMarifer from "components/dataGridMarifer/dataGridMarifer";
import OrderOutput from "./OrderOutput";

const PedidosTable = ({ data, setRefresh, refresh }) => {
  const { userName } = useSelector(({ session }) => session);
  const [open, setOpen] = useState(false);
  const [openSummary, setOpenSummary] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openBordado, setOpenBordado] = useState(false);
  const [mode, setMode] = useState("POST");
  const [dataColumns, setDataColumns] = useState(null);
  const [openCut, setOpenCut] = useState(false);
  const [openStamping, setOpenStamping] = useState(false);
  const [openOrderOutputs, setOrderOutputs] = useState(false);
  const [openEvent, setOpenEvent] = useState(false);
  const dispatch = useDispatch();
  const changeStatusHandle = async (e, option, pedidoId) => {
    if (!option) return;
    await updateStatus(option, pedidoId, userName);
    dispatch(
      showMessage({
        variant: "success",
        message: `El pedido ha cambiado de estatus: el nuevo estatus es ${option.nombre} `,
      })
    );
  };
  useEffect(() => {
    const fetchData = async () => {
      let status = await getAllStatus();
      let col = columns(
        setOpen,
        setMode,
        setOpenDelete,
        dispatch,
        setOpenCut,
        setOpenSummary,
        status,
        changeStatusHandle,
        setOpenEvent,
        setOpenStamping,
        setOpenBordado,
        setOpenEvent,
        setRefresh,
        setOrderOutputs,
        refresh
      );

      setDataColumns(col);
    };
    fetchData();
  }, [open, dispatch, openDelete, refresh]);

  const handleClose = () => {
    setOpen(false);
    setRefresh(!refresh);
  };
  const handleCloseCut = () => {
    setOpenCut(false);
  };
  const handleCloseStamping = () => {
    setOpenStamping(false);
  };

  const handleCloseBordado = () => {
    setOpenBordado(false);
  };

  const setAndOpen = () => {
    setOpen(true);
    setMode("POST");
  };
  const handleCloseSummary = () => {
    setOpenSummary(false);
  };
  const handleCloseEvent = () => {
    setOpenEvent(false);
  };
  const handleCloseOrderOutputs = () => {
    setOrderOutputs(false);
  };

  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <OrderSummaryModalPDF
        open={openSummary}
        handleClose={handleCloseSummary}
      />
      <EventSummary open={openEvent} handleClose={handleCloseEvent} />
      <StampingOrderMainModal
        open={openStamping}
        handleClose={handleCloseStamping}
      />
      <OrderBordadoMain open={openBordado} handleClose={handleCloseBordado} />
      <OrderCutMainModal open={openCut} handleClose={handleCloseCut} />
      <OrderOutput
        open={openOrderOutputs}
        handleClose={handleCloseOrderOutputs}
      />
      <DeletePedido openDelete={openDelete} setOpenDelete={setOpenDelete} />
      <PedidosDrawer open={open} handleClose={handleClose} mode={mode} />

      <Card extra={"w-full h-full p-5"}>
        <div className="relative flex items-center justify-end">
          <Tooltip title="Crear Nuevo Pedido" placement="top">
            <button
              onClick={setAndOpen}
              className="flex min-w-[80px] items-center
                 justify-center rounded-md bg-pink-500
                 px-3 py-2 text-white shadow-md transition hover:bg-pink-600
                 active:bg-pink-700"
            >
              <AddCircleIcon className="text-white" />
            </button>
          </Tooltip>
        </div>

        {data ? (
          <DataGridMarifer rows={data || []} columns={dataColumns || []} />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};
export default PedidosTable;
